<template>
  <el-container>
    <el-header height="220">
      <h3>运行日志</h3>
    </el-header>
    <el-main>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'AdminRuntimeLog',
  data() {
    return {
      // 屏幕宽度, 为了控制分页条的大小
      screenWidth: document.body.clientWidth,
      currentPage: 1,
      pageSize: 12,
      totalSize: 0,
      dataList: [],
      nextId: 0
    }
  },
  created() {
    document.title = '运行日志'
    this.getData()
  },
  methods: {
    getData() {
    }
  }
}
</script>

<style>
</style>
